// ========== 1) 福利厚生：ランダムカード + pin ==========

const initEmployee = () => {
  const section = document.getElementById('js-anime-employee');
  const wrapper = document.getElementById('js-anime-employee-ttl');
  const txt1 = document.getElementById('js-anime-employee-txt1');
  const txt2 = document.getElementById('js-anime-employee-txt2');
  const cards = gsap.utils.toArray('#js-anime-employee .p-common-employee__card');
  const ttl2 = document.getElementById('js-anime-employee-ttl2');

  if (!section || !wrapper || !txt1 || !txt2 || !ttl2 || !cards.length) return;

  const mm = gsap.matchMedia();

  mm.add(
    {
      isMobile: '(max-width: 767px)',
      isPC: '(min-width: 768px)',
    },
    (context) => {
      const { isMobile } = context.conditions;

      // ✅ SP/PCでここだけ変える
      const TITLE_START_SIZE = isMobile ? '20vw' : '20vw'; // 初期（でかい状態）
      const TITLE_END_SIZE = isMobile ? '7.5vw' : '5vw'; // 着地（小さい状態）

      // 既存の初期化（mm内に入れて、サイズ反映）
      const setInitialTitle = () => {
        gsap.killTweensOf([wrapper, txt1, txt2]);
        gsap.set(wrapper, { clearProps: 'fontSize' });
        gsap.set([txt1, txt2], {
          fontSize: TITLE_START_SIZE,
          rotate: -10,
          opacity: 0,
          willChange: 'transform,font-size',
          display: 'inline-block',
          transformOrigin: '50% 50%',
        });
      };
      setInitialTitle();

      // 既存の tlTitle（mm内に）
      const tlTitle = gsap.timeline({
        defaults: { overwrite: 'auto' },
        scrollTrigger: {
          trigger: section,
          start: 'top 80%',
          end: 'top bottom',
          toggleActions: 'restart none restart reset',
          // markers: true,
        },
      });

      tlTitle
        .to(
          txt1,
          {
            fontSize: TITLE_END_SIZE,
            rotate: -5,
            opacity: 1,
            duration: 0.8,
            ease: 'power2.out',
          },
          0,
        )
        .to(
          txt2,
          {
            fontSize: TITLE_END_SIZE,
            rotate: -5,
            opacity: 1,
            duration: 0.8,
            ease: 'power2.out',
          },
          0.4,
        )
        .add(() => {
          [txt1, txt2].forEach((el) => (el.style.willChange = 'auto'));
        });

      // ✅ mm切替時に片付け（重要：重複防止）
      return () => {
        tlTitle.kill();
        // tlTitleが作ったScrollTriggerだけ消すのが理想だけど、簡易ならこれでもOK
        ScrollTrigger.getAll()
          .filter((st) => st.trigger === section)
          .forEach((st) => st.kill());
      };
    },
  );

  // --- pin セクション ---
  const PIN_LENGTH = 1000;
  ScrollTrigger.create({
    trigger: section,
    start: 'top top',
    end: `+=${PIN_LENGTH}%`,
    pin: true,
    pinSpacing: true,
    anticipatePin: 1,
    // markers: true,
  });

  // --- カード演出 ---
  const order = gsap.utils.shuffle(cards.slice());

  order.forEach((el, i) => {
    gsap.set(el, {
      opacity: 0,
      scale: 5,
      rotate: gsap.utils.random(-35, 35),
      filter: 'blur(14px)',
      transformOrigin: '50% 50%',
      willChange: 'transform,opacity,filter',
      backfaceVisibility: 'hidden',
      zIndex: i + 1,
    });
  });

  const tlCards = gsap.timeline({
    defaults: { ease: 'power3.out' },
    scrollTrigger: {
      trigger: section,
      start: 'top top',
      end: `+=${PIN_LENGTH}%`,
      scrub: true,
      // markers: true,
    },
  });

  const HOLD = 2.0; // ← ここを増やすほど「しばらくスクロール」区間が長くなる
  tlCards.to({}, { duration: HOLD });

  const STEP = 0.35;
  const pattern = [-6, -4, -2, 0, 2, 4, 6];

  order.forEach((el, i) => {
    const finalRot = pattern[i % pattern.length];
    const startRot = finalRot + gsap.utils.random(-40, 40);

    gsap.set(el, {
      opacity: 0,
      scale: 5,
      rotate: startRot,
      filter: 'blur(14px)',
      transformOrigin: '50% 50%',
      willChange: 'transform,opacity,filter',
      backfaceVisibility: 'hidden',
      zIndex: i + 1,
    });

    tlCards.to(
      el,
      {
        opacity: 1,
        scale: 1.5,
        rotate: finalRot,
        filter: 'blur(0px)',
        duration: 0.8,
        ease: 'power3.out',
        onComplete: () => (el.style.willChange = 'auto'),
      },
      HOLD + i * STEP,
    );
  });

  const endCardsPos = HOLD + (order.length - 1) * STEP + 0.8;
  const GAP_BEFORE_TTL2 = 2.0; // ← ここを増やすほど「間」が長くなる
  tlCards.to({}, { duration: GAP_BEFORE_TTL2 }, endCardsPos);

  const ttl2Pos = endCardsPos + GAP_BEFORE_TTL2;

  gsap.set(ttl2, {
    yPercent: -50,
    opacity: 0,
    scale: 5,
    rotate: -10,
    filter: 'blur(14px)',
    transformOrigin: '50% 50%',
    willChange: 'transform,opacity,filter',
  });

  tlCards.to(
    ttl2,
    {
      yPercent: -50,
      opacity: 1,
      scale: 1,
      rotate: -5, // txt1 と同じ着地
      filter: 'blur(0px)',
      duration: 3,
      ease: 'power3.out',
      onComplete: () => (ttl2.style.willChange = 'auto'),
    },
    ttl2Pos,
  );

  const HOLD_AFTER_TTL2 = 4.0;
  tlCards.to({}, { duration: HOLD_AFTER_TTL2 }, ttl2Pos + 0.9);
};

// ========== 2) 目指していること：横スクロール + 中央拡大 ==========

const initGoal = () => {
  const section = document.getElementById('js-anime-goal');
  if (!section) return;

  const bg = section.querySelector('.p-common-goal__bg');
  const ttl = document.getElementById('js-anime-goal-ttl');
  const txt1 = document.getElementById('js-anime-goal-txt1');
  const cardsWrap = section.querySelector('.p-common-goal__cards');
  const cards = gsap.utils.toArray('.p-common-goal__card');

  if (!ttl || !txt1 || !cardsWrap || !cards.length) return;

  // --- タイトル演出（中央にふわっと） ---
  gsap.set(txt1, {
    fontSize: '20vw',
    rotate: -10,
    opacity: 0,
    willChange: 'transform,font-size',
    display: 'inline-block',
    transformOrigin: '50% 50%',
  });

  gsap
    .timeline({
      scrollTrigger: {
        trigger: section,
        start: 'top 80%',
        end: 'top 50%',
        toggleActions: 'play none none reverse',
        // markers: true,
      },
    })
    .to(
      txt1,
      {
        fontSize: '5vw',
        rotate: -5,
        opacity: 1,
        duration: 0.8,
        ease: 'power2.out',
      },
      0,
    );

  // --- カードのベース状態 ---
  gsap.set(cards, {
    scale: 0.9,
    opacity: 0.6,
    willChange: 'transform,opacity',
  });

  let activeCard = null;

  // 中央に近いほど scale / opacity を上げる
  const updateCards = () => {
    const centerX = window.innerWidth / 2;
    let closest = null;
    let closestDist = Infinity;

    cards.forEach((card) => {
      const rect = card.getBoundingClientRect();
      const cardCenter = rect.left + rect.width / 2;
      const dist = Math.abs(centerX - cardCenter);

      if (dist < closestDist) {
        closestDist = dist;
        closest = card;
      }

      const maxDist = centerX + rect.width;
      const ratio = gsap.utils.clamp(0, 1, dist / maxDist);

      const scale = 0.85 + (1 - ratio) * 1.2;
      const opacity = 0.4 + (1 - ratio) * 0.6;

      gsap.set(card, {
        scale,
        opacity,
        zIndex: Math.round((1 - ratio) * 100),
      });
    });

    if (closest && closest !== activeCard) {
      if (activeCard) activeCard.classList.remove('is-active');
      closest.classList.add('is-active');
      activeCard = closest;
    }
  };

  // --- 横スクロール + pin ---
  gsap.fromTo(
    cardsWrap,
    {
      x: () => window.innerWidth,
    },
    {
      x: () => {
        const total = cardsWrap.scrollWidth;
        const vw = window.innerWidth;
        return -(total - vw * 0.4);
      },
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top top',
        end: () => '+=' + (cardsWrap.scrollWidth + window.innerWidth),
        scrub: true,
        pin: section,
        pinSpacing: true,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        onUpdate: updateCards,
        onRefresh: updateCards,
        // markers: true,
      },
    },
  );
};

// ========== 3) それが私達3LINKS：似てるけど少し軽めの演出 ==========

const initPhilosophy = () => {
  const section = document.getElementById('js-anime-philosophy');
  if (!section) return;

  // 各テキスト要素を取得
  const mainText = document.getElementById('js-common-philosophy__ttl'); // 感謝の気持ち
  const subText = document.getElementById('js-common-philosophy__sttl'); // 働く人すべての人にありがとうと言いたい。
  const endBlock = document.getElementById('js-anime-philosophy-txt1'); // それが私達【3LINKS】です

  if (!mainText || !subText || !endBlock) return;

  const mm = gsap.matchMedia();

  mm.add(
    {
      isMobile: '(max-width: 767px)',
      isPC: '(min-width: 768px)',
    },
    (context) => {
      const { isMobile } = context.conditions;

      const TITLE_SIZE = isMobile ? '18vw' : '8vw';

      // --- 初期状態 ---
      gsap.killTweensOf([mainText, subText, endBlock]);

      gsap.set([mainText, subText, endBlock], {
        opacity: 0,
        y: 20,
        willChange: 'transform,opacity,font-size',
      });

      // --- スクロール連動タイムライン ---
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: 'top top', // 画面上端に来たら発火
          end: '+=500%', // スクロール量（体感で調整：200〜300%くらい）
          scrub: true, // スクロール量に応じて進行
          pin: true, // セクションを固定
          pinSpacing: true,
          anticipatePin: 1,
          // markers: true,
        },
      });

      // 1) 感謝の気持ち
      tl.to(mainText, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: 'power2.out',
        onComplete: () => (mainText.style.willChange = 'auto'),
      });

      // 2) 働く人すべての人にありがとうと言いたい。
      tl.to(subText, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: 'power2.out',
        onComplete: () => (subText.style.willChange = 'auto'),
      });

      // 3) それが私達【3LINKS】です
      tl.to(endBlock, {
        opacity: 1,
        y: 100,
        fontSize: TITLE_SIZE,
        duration: 1,
        ease: 'power2.out',
        rotate: -10,
        onComplete: () => (endBlock.style.willChange = 'auto'),
      });

      // 4) 余韻ゾーン（見た目は何も変えないダミー）
      tl.to(
        {},
        {
          duration: 1.5, // ← ここが「余韻に浸れる」スクロール割合
        },
      );
    },
  );
};

// ========== エントリーポイント ==========

const init = () => {
  initEmployee();
  initGoal();
  initPhilosophy();
};

export default { init };
